// components/LSSF/CataractApplicationsList.jsx
import React from 'react';
import BaseList from './BaseList';

const CataractApplicationsList = () => {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'age', label: 'Age' },
    { key: 'id_card_number', label: 'ID Card Number' },
    { key: 'id_card_type', label: 'ID Card Type' },
    { key: 'parent_spouse_name', label: 'Parent/Spouse Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'address', label: 'Address' },
    { key: 'eye_disease', label: 'Eye Disease' },
  ];

  return (
    <BaseList
      title="Cataract Camp Applications"
      apiEndpoint="/api/v1/mail/cataract-camp-form"
      columns={columns}
      addButtonLink="/dashboard/lssf/add-cataract-application"
      addButtonText="Add Cataract Application"
    />
  );
};

export default CataractApplicationsList;